import { Form, InputNumber, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['checkin_setting.enabled', 'checkin_setting.min_quota', 'checkin_setting.max_quota']

export default function CheckinSection({ options }: { options: OptionsAPI }) {
  const { getNumber, getBool, patch } = options

  return (
    <SettingSectionCard title="签到设置" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="启用签到">
            <Switch
              checked={getBool('checkin_setting.enabled')}
              onChange={(v) => patch({ 'checkin_setting.enabled': v })}
            />
          </Form.Item>
          <Form.Item label="最小奖励额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('checkin_setting.min_quota', 1000)}
              onChange={(v) => patch({ 'checkin_setting.min_quota': v ?? 1000 })}
            />
          </Form.Item>
          <Form.Item label="最大奖励额度">
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              value={getNumber('checkin_setting.max_quota', 10000)}
              onChange={(v) => patch({ 'checkin_setting.max_quota': v ?? 10000 })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
